import { useState } from "react";
import classes from "./ForgotPasswordForm.module.css";
import { Button, Heading, Input, Text } from "components/common";
import Header from "../../Header/Header";

const ForgotPasswordForm = ({ setStep }) => {
  const [email, setEmail] = useState();
  const handleResetLink = () => {
    setStep((prev) => prev + 1);
  };
  return (
    <div className={classes.container}>
      <Header
        heading="Forgot Your Password?"
        info="Enter your email address, and we’ll send you instructions to reset your password."
      />
      <div className={classes.inputWrapper}>
        <Input
          name="email"
          value={email}
          setValue={setEmail}
          type="email"
          placeholder="Email address"
        />{" "}
        <Button wFull onClick={handleResetLink}>
          Send Reset Link
        </Button>
      </div>
      <div className={classes.backTo}>
        <Text sm primitive200>
          Back to
        </Text>
        <Button transparent to="/login" className={classes.button} sm>
          Login
        </Button>
      </div>
    </div>
  );
};
export default ForgotPasswordForm;
